"use strict";

(() => {
    const ratingSnippets = document.querySelectorAll('.ruk_rating_snippet');

    if (!ratingSnippets.length) return;

    const applyStarStyle = (el) => {
        el.style.setProperty('color', '#ba8c2d', 'important');
    };

    ratingSnippets.forEach(ratingSnippet => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node instanceof HTMLElement && node.tagName.toLowerCase() === 'i') {
                        applyStarStyle(node);
                    }
                });
            });
        });

        observer.observe(ratingSnippet, {
            childList: true,
            subtree: true
        });
    });
})();
